// main.ts
import { createApp } from "vue";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import App from "./App.vue";
import router from './router/index'
import "./assets/css/style.scss"; // 引入全局样式文件
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
const app = createApp(App);

app.use(ElementPlus, { locale: zhCn });
app.use(router)
app.mount("#app");
